//////////////////////////////////////////
//                      通用函数文件               //
//////////////////////////////////////////
/**
* 将相对地址转换为绝对地址
*/
function ToAbsoluteURL(url, base) {
var ele = document.createElement('a');
ele.href = (base || '') + url;
return ele.href;
}

function SaveToFile(base64Content, fileName, fileExt) {//保存到文件
var c = window.atob(base64Content);
var ab = new ArrayBuffer(c.length);
var ia = new Uint8Array(ab);
for (var i = 0; i < c.length; i++) {
ia[i] = c.charCodeAt(i);
}
var b = new Blob([ab]);//这句，Windows版本的Safari执行不下去。

if (fileName == undefined || fileName == null || fileName == '') {
fileName = "noname";
}
fileName += '.';
fileName += fileExt;
saveAs(b, fileName);
}

/**Base64解码
* @strIn，输入字符串
* 成功返回一个数组，每一个元素包含一字节信息，失败返回null
*/
function decodeBase64(strIn) {
    if (!strIn.length || strIn.length % 4)
        return null;
    var str64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var index64 = [];
    for (var i = 0; i < str64.length; i++)
        index64[str64.charAt(i)] = i;
    var c0, c1, c2, c3, b0, b1, b2;
    var len = strIn.length;
    var len1 = len;
    if (strIn.charAt(len - 1) == '=')
        len1 -= 4;
    var result = [];
    for (var i = 0, j = 0; i < len1; i += 4) {
        c0 = index64[strIn.charAt(i)];
        c1 = index64[strIn.charAt(i + 1)];
        c2 = index64[strIn.charAt(i + 2)];
        c3 = index64[strIn.charAt(i + 3)];
        b0 = (c0 << 2) | (c1 >> 4);
        b1 = (c1 << 4) | (c2 >> 2);
        b2 = (c2 << 6) | c3;
        result.push(b0 & 0xff);
        result.push(b1 & 0xff);
        result.push(b2 & 0xff);
    }
    if (len1 != len) {
        c0 = index64[strIn.charAt(i)];
        c1 = index64[strIn.charAt(i + 1)];
        c2 = strIn.charAt(i + 2);
        b0 = (c0 << 2) | (c1 >> 4);
        result.push(b0 & 0xff);
        if (c2 != '=') {
            c2 = index64[c2];
            b1 = (c1 << 4) | (c2 >> 2);
            result.push(b1 & 0xff);
        }
    }
    return result;
}

/* FileSaver.js
* A saveAs() FileSaver implementation.
* 1.3.2
* 2016-06-16 18:25:19
*
* By Eli Grey, http://eligrey.com
* License: MIT
*   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
*/

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
    "use strict";
    // IE <10 is explicitly unsupported
    if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
        return;
    }
    var 
          doc = view.document
    // only get URL when necessary in case Blob.js hasn't overridden it yet
        , get_URL = function() {
            return view.URL || view.webkitURL || view;
        }
        , save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
        , can_use_save_link = "download" in save_link
        , click = function(node) {
            var event = new MouseEvent("click");
            node.dispatchEvent(event);
        }
        , is_safari = /constructor/i.test(view.HTMLElement) || view.safari
        , is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent)
        , throw_outside = function(ex) {
            (view.setImmediate || view.setTimeout)(function() {
                throw ex;
            }, 0);
        }
        , force_saveable_type = "application/octet-stream"
    // the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
        , arbitrary_revoke_timeout = 1000 * 40 // in ms
        , revoke = function(file) {
            var revoker = function() {
                if (typeof file === "string") { // file is an object URL
                    get_URL().revokeObjectURL(file);
                } else { // file is a File
                    file.remove();
                }
            };
            setTimeout(revoker, arbitrary_revoke_timeout);
        }
        , dispatch = function(filesaver, event_types, event) {
            event_types = [].concat(event_types);
            var i = event_types.length;
            while (i--) {
                var listener = filesaver["on" + event_types[i]];
                if (typeof listener === "function") {
                    try {
                        listener.call(filesaver, event || filesaver);
                    } catch (ex) {
                        throw_outside(ex);
                    }
                }
            }
        }
        , auto_bom = function(blob) {
            // prepend BOM for UTF-8 XML and text/* types (including HTML)
            // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
            if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
                return new Blob([String.fromCharCode(0xFEFF), blob], { type: blob.type });
            }
            return blob;
        }
        , FileSaver = function(blob, name, no_auto_bom) {
            if (!no_auto_bom) {
                blob = auto_bom(blob);
            }
            // First try a.download, then web filesystem, then object URLs
            var 
                  filesaver = this
                , type = blob.type
                , force = type === force_saveable_type
                , object_url
                , dispatch_all = function() {
                    dispatch(filesaver, "writestart progress write writeend".split(" "));
                }
            // on any filesys errors revert to saving with object URLs
                , fs_error = function() {
                    if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
                        // Safari doesn't allow downloading of blob urls
                        var reader = new FileReader();
                        reader.onloadend = function() {
                            var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
                            var popup = view.open(url, '_blank');
                            if (!popup) view.location.href = url;
                            url = undefined; // release reference before dispatching
                            filesaver.readyState = filesaver.DONE;
                            dispatch_all();
                        };
                        reader.readAsDataURL(blob);
                        filesaver.readyState = filesaver.INIT;
                        return;
                    }
                    // don't create more object URLs than needed
                    if (!object_url) {
                        object_url = get_URL().createObjectURL(blob);
                    }
                    if (force) {
                        view.location.href = object_url;
                    } else {
                        var opened = view.open(object_url, "_blank");
                        if (!opened) {
                            // Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
                            view.location.href = object_url;
                        }
                    }
                    filesaver.readyState = filesaver.DONE;
                    dispatch_all();
                    revoke(object_url);
                }
            ;
            filesaver.readyState = filesaver.INIT;

            if (can_use_save_link) {
                object_url = get_URL().createObjectURL(blob);
                setTimeout(function() {
                    save_link.href = object_url;
                    save_link.download = name;
                    click(save_link);
                    dispatch_all();
                    revoke(object_url);
                    filesaver.readyState = filesaver.DONE;
                });
                return;
            }

            fs_error();
        }
        , FS_proto = FileSaver.prototype
        , saveAs = function(blob, name, no_auto_bom) {
            return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
        }
    ;
    // IE 10+ (native saveAs)
    if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
        return function(blob, name, no_auto_bom) {
            name = name || blob.name || "download";

            if (!no_auto_bom) {
                blob = auto_bom(blob);
            }
            return navigator.msSaveOrOpenBlob(blob, name);
        };
    }

    FS_proto.abort = function() { };
    FS_proto.readyState = FS_proto.INIT = 0;
    FS_proto.WRITING = 1;
    FS_proto.DONE = 2;

    FS_proto.error =
    FS_proto.onwritestart =
    FS_proto.onprogress =
    FS_proto.onwrite =
    FS_proto.onabort =
    FS_proto.onerror =
    FS_proto.onwriteend =
        null;

    return saveAs;
} (
       typeof self !== "undefined" && self
    || typeof window !== "undefined" && window
    || this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
    module.exports.saveAs = saveAs;
} else if ((typeof define !== "undefined" && define !== null) && (define.amd !== null)) {
    define("FileSaver.js", function() {
        return saveAs;
    });
}


function SpecialCharInJson(source) {
	var str='';
	if(source==null || source==undefined) {
		return str;
	}
	var i, num = source.length;
	var ch;
	for (i = 0; i < num; i++) {
	    ch=source.charAt(i);
	    switch (ch) {
			case '\"':        
				str+="\\\"";        
				break;        
			case '\\':        
				str+="\\\\";        
				break;        
			case '/':        
				str+="\\/";        
				break;        
			case '\b':        
				str+="\\b";        
				break;        
			case '\f':        
				str+="\\f";        
				break;        
			case '\n':        
				str+="\\n";        
				break;        
			case '\r':        
				str+="\\r";        
				break;        
			case '\t':        
				str+="\\t";        
				break;        
			default:
			    str += ch;
				break;
		}
	}
	return str;
}

/**
* 打天下
* 基于浏览器的JavaScript类
*/
export function classPrintWorld(url) {
    //this.jsonDataInDialog="";
    this.http2FlexPrint = null;
    this.syncHttp2FlexPrint = null;
    this.lastError = "";
    this.lastResponseText = "";
    if (url == null || url == undefined || url=="") {
        this.flexPrintURL = "http://127.0.0.1:8888"; //打天下打印服务器之缺省地址
    } else {
        this.flexPrintURL = this.NormalizedURL(url);
    }
}

/**
* 为打天下指定访问某资源的token。
* @url，网址。打天下访问该url路径及其子路径的资源，在http header中都会加上本token。
* @item，token名称，打天下打印服务将它与参数@val一起，加在http header中。
* @val，token的值
* 对于打天下服务器来说，在其运行期间，此token一直有效，除非你通过本方法更改了它。
*/
classPrintWorld.prototype.AccessToken=function(url, item, val) {
    var json = {};
    json.action = "token";
    json.url = url;
    json.item = item;
    json.val = val
    json = this.Direct(json); //直接发送数据到打印服务器（同步调用方法）
    if (json == null) {//数据发送失败
        alert(this.GetLastError());
    } else if (json.error != undefined) {//打天下打印服务返回的错误信息
        alert(json.error);
    }
}

classPrintWorld.prototype.NormalizedURL = function (url) {
    url=url.trim();
    while (url.length>0 && url.lastIndexOf('/') == url.length - 1) {
        url = url.substr(0, url.length - 1);
    }
    return url;
}

classPrintWorld.prototype.PrintURL = function() {
    return this.flexPrintURL;
}

classPrintWorld.prototype.GetLastError = function() {
    return this.lastError;
}

classPrintWorld.prototype.GetResponseText = function() {
    return this.lastResponseText;
}

/**
* 获取HTTP对象
*/
classPrintWorld.prototype.GetHTTP = function() {
    if (this.http2FlexPrint == null) {
        this.http2FlexPrint = new XMLHttpRequest();

        if ("withCredentials" in this.http2FlexPrint) {
        } else if (typeof XDomainRequest != "undefined") {
            this.http2FlexPrint = new XDomainRequest();
        } else {
            this.http2FlexPrint = null;
            this.lastError = "浏览器创建HTTP对象失败，你可能需要升级或者更换浏览器。";
        }
    }
    return this.http2FlexPrint;
}

classPrintWorld.prototype.GetSyncHTTP = function() {
    if (this.syncHttp2FlexPrint == null) {
        this.syncHttp2FlexPrint = new XMLHttpRequest();

        if ("withCredentials" in this.syncHttp2FlexPrint) {
        } else if (typeof XDomainRequest != "undefined") {
            this.syncHttp2FlexPrint = new XDomainRequest();
        } else {
            this.syncHttp2FlexPrint = null;
            this.lastError = "浏览器创建HTTP对象失败，你可能需要升级或者更换浏览器。";
        }
    }
    return this.syncHttp2FlexPrint;
}

classPrintWorld.prototype.GetTempHTTP = function() {
    var http= new XMLHttpRequest();
    if ("withCredentials" in http) {
    } else if (typeof XDomainRequest != "undefined") {
        http = new XDomainRequest();
    } else {
        http = null;
        this.lastError = "浏览器创建HTTP对象失败，你可能需要升级或者更换浏览器。";
    }
    return http;
}

/**
* 向URL指向的打天下打印服务（FlexPrint）同步 or 异步发送JSON数据。
* @jsonData，JSON格式数据，字符串类型
* @callbackFunc，回调函数
* @async，是否异步，true为异步；false为同步
*/
classPrintWorld.prototype.Act = function(jsonData, callbackFunc, async) {
    this.lastError = "";
    var http = null;
    if (callbackFunc == null || callbackFunc == undefined) {
        callbackFunc = this.DefaultAsyncCallbackForAct;
    }
    if (typeof (callbackFunc) === "function") {
        http = this.GetTempHTTP();
        //http = this.GetHTTP();
        if (http == null) {
            return false;
        }
        try {
            if (typeof (jsonData) === 'object') {
                jsonData = JSON.stringify(jsonData); //转换为字符串
            }
        } catch (err) {
            this.lastError = err;
            return false;
        }
        if (async == undefined || async == null) {
            async = true;
        }
        try {
            http.onreadystatechange = callbackFunc;
            http.open("POST", this.flexPrintURL, async);
            http.send(jsonData); //发送数据到打印服务器FlexPrint
        } catch (err) {
            this.lastError = err + "\n可能的原因是：打天下（FlexPrint）尚未安装、启动，或者是URL指向错误。";
            return false;
        }
        if (!async) {//同步调用
            http.onreadystatechange();
        }
        return true;
    } else {
        this.lastError = "Action参数错误：回调函数参数callbackFunc不是函数。"
    }
    return false;
}

/**
* 向URL指向的打天下打印服务（FlexPrint）异步同步发送JSON数据。
*/
classPrintWorld.prototype.Direct = function(jsonData,jsonErrInfo) {
    this.lastError = "";
    if (this.GetSyncHTTP() == null) {
        if(jsonErrInfo!=null && jsonErrInfo!=undefined && typeof (jsonErrInfo) === 'object') {
            jsonErrInfo.errno=1;
            jsonErrInfo.errinfo=this.lastError;
        }
        return null;
    }
    try {
        if (typeof (jsonData) === 'object') {
            jsonData = JSON.stringify(jsonData); //转换为字符串
        }
    } catch (err) {
        this.lastError = err;
        if(jsonErrInfo!=null && jsonErrInfo!=undefined && typeof (jsonErrInfo) === 'object') {
            jsonErrInfo.errno=2;
            jsonErrInfo.errinfo=this.lastError;
        }
        return null;
    }

    try {
        this.syncHttp2FlexPrint.onreadystatechange = null;
        this.syncHttp2FlexPrint.open("POST", this.flexPrintURL, false);
        this.syncHttp2FlexPrint.send(jsonData); //发送数据
    } catch (err) {
        this.lastError = err + "\n可能的原因是：打天下（FlexPrint）尚未安装、启动，或者是URL指向错误。";
        if(jsonErrInfo!=null && jsonErrInfo!=undefined && typeof (jsonErrInfo) === 'object') {
            jsonErrInfo.errno=3;
            jsonErrInfo.errinfo=this.lastError;
        }
        return null;
    }
    var json = null; // = eval("(" + this.http2FlexPrint.responseText + ")"); //返回，以JSON对象形式。
    this.lastResponseText = this.syncHttp2FlexPrint.responseText;
    //alert(this.syncHttp2FlexPrint.responseText);
    try {
        json = JSON.parse(this.syncHttp2FlexPrint.responseText);
    } catch (err) {
        this.lastError = "返回的JSON数据解析出错: " + err;
        if(jsonErrInfo!=null && jsonErrInfo!=undefined && typeof (jsonErrInfo) === 'object') {
            jsonErrInfo.errno=4;
            jsonErrInfo.errinfo=this.lastError;
        }
        return null;
    }
    if (json == null || (json.error != undefined)) {
        return json;
    } else if (json.cmd == "preview") {//跳转到预览页面
        window.open(this.PrintURL() + '/' + json.val, '_blank');
    } else if (json.cmd == "previewfile") {//跳转到预览页面
        window.open(this.PrintURL() + '/' + json.val+"&file=1", '_blank'); 
    } else if (json.cmd == 'print2file') {//打印到文件
        SaveToFile(json.val, json.name, json.ext);
    }
    return json;
}

/**
* 获取打天下服务器版本
*/
classPrintWorld.prototype.Version = function () {//同步方式获取打天下服务器版本
    var ver = "";
    var json = "{\"action\":\"whoareyou\"}";
    json = this.Direct(json);
    if (json != null && json.cmd == "whoareyou") {//打印服务已经启动
        ver = json.val.version;
    }
    return ver;
}

/**
* 检测打天下打印服务是否安装启动
* @version，版本号，字符串类型。若不提供此参数，则不检查版本。
* 返回值：-1或者<0，未安装/启动，需要安装；0，已经安装并启动不需要安装；1或者>0，有新版本，提示用户下载安装。
*/
classPrintWorld.prototype.CheckInstallation = function(version,checkpdf) {//同步方式检测本机是否安装启动了打天下服务
    var jsonInfo={};
    jsonInfo.errno=0;
    jsonInfo.errinfo="";
    var json ={};// "{\"action\":\"whoareyou\"}";
    json.action="whoareyou";
    json.checkpdf=checkpdf;
    json = this.Direct(json,jsonInfo);
    if (json != null && json.cmd == "whoareyou") {//打印服务已经启动
        if(checkpdf) {
            if(json.val.pdf=="Disabled") {//PDF打印版本未安装
                return -1;
            }
        }
        if (version != null && version != undefined && version != "") {
            if (version > json.val.version) {
                return 1; //有新版本
            } else if (version < json.val.version) {
                return 2; //用旧版本
            }
        }
        return 0; //安装并已启动
    } else if(jsonInfo.errno>0) {
        if(jsonInfo.errno==3) {//尚未安装/启动打印打天下服务器
        } else {    //出现错误
            alert(jsonInfo.errinfo);
            return 99;
        }
    }
    return -1; //尚未安装/启动打印打天下服务器
}

/**
* 有alert信息的版本。用于发现并提示CheckInstallation中的问题。
*/
classPrintWorld.prototype.CheckInstallationAlert = function (version) {//同步方式检测本机是否安装启动了打天下服务
    var json = "{\"action\":\"whoareyou\"}";
    json = this.Direct(json);
    if (json != null) {
        if (json.cmd == "whoareyou") {//打印服务已经启动
            if (version != null && version != undefined) {
                if (version > json.val.version) {
                    return 1; //有新版本
                } else if (version < json.val.version) {
                    return 2;//恢复旧版
                }
            }
            return 0; //安装并已启动
        } else {
            alert("Unexpected data: " + this.lastResponseText);
        }
    } else {// json == null
        if (this.lastError != "") {
            alert(this.lastError);
        }
        alert("Unexpected data: " + this.lastResponseText);
    }
    return -1; //尚未安装/启动打印打天下服务器
}

function TheSystemIsWindows() {
    return ((navigator.platform == "Win32") || (navigator.platform == "Windows"));
}
/**
* 检测本机打天下打印服务是否安装启动，根据检测结果提示下载安装。
* @downloadURL下载地址，可相对地址，形式如：/download/Install_c.exe
* @version，版本号，字符串类型。形式如：'1.0.0.5'，缺省，则不会更新下载。
* 返回值：true or false。
* 如果返回false，说明未安装/启动，或者下载了打天下。因此，这时候就需要退出执行打天下相关的代码，待到安装后再执行即可。
* 以下以预览(打印一样)为例说明：
*
* function OnPreview() {
*   if(!CheckInstallationPrompt("/download/Install_c.exe",'1.0.0.5') {
*       return;//需要安装或者启动打天下打印服务器
*   }
*   ...//预览相关代码
* }
*/
function CheckInstallationPrompt(downloadURL, version,checkpdf) {
    var printWorld = new classPrintWorld();
    document.body.style.cursor = "wait";
    var r = printWorld.CheckInstallation(version,checkpdf);
    document.body.style.cursor = "default";
    var bContinue = true;
    if (r != 0) {
        var prompt;
        if (r < 0) {
            bContinue = false;
            if(checkpdf) {
                prompt = "友情提示：尚未安装/启动打天下PDF打印服务！\n请单击确定，下载安装。";
            } else {
                prompt = "友情提示：尚未安装/启动打天下打印服务！\n请单击确定，下载安装。";
            }
        } else if (r==1) {
            prompt = "友情提示：有新版本("+version+")的打天下打印服务！\n请单击确定，下载安装。";
        } else if (r == 2) {
            prompt = "友情提示：退回旧版本("+version+")的打天下打印服务？\n请单击确定，下载安装。";
        } else if (r==99) {//出错，且出错信息已在CheckInstallation中显示。
            return false;
        }
        if (confirm(prompt)) {
            printWorld.DownloadFile(downloadURL);
            bContinue = false;
        }
    }
    return bContinue;
}
        
/**
* 下载文件。主要用于下载安装程序。
*/
classPrintWorld.prototype.DownloadFile=function (downloadURL) {
var form = document.createElement("form");
document.body.appendChild(form);
form.method = 'get';
form.action = downloadURL;
form.submit();
document.body.removeChild(form);
}

/**
* 动态证书。这也是一种使用证书的方式。
* @content：证书字符串。
*/
classPrintWorld.prototype.Certificate = function(content) {
    var json = {};
    json.action = "certificate";
    json.content = content;
    return this.Direct(json);
}

classPrintWorld.prototype.DefaultAsyncCallbackForAct = function () {//异步调用打天下打印服务的回调函数
    if (this.readyState != 4) {// 4 = "loaded"
        return;
    }
    if (this.status == 200) {// 200 = OK
        var json = eval("(" + this.responseText + ")");
        if (json.error != undefined) {//返回错误信息
            alert(json.error);
        } else if (json.cmd == "printers") {//打印机列表
            //Printers2List(json);
        } else if (json.cmd == "print") {//打印已提交，无需再做处理。
        } else if (json.cmd == 'print2file') {//打印到文件
            SaveToFile(json.val, json.name, json.ext); //保存文件
        } else if (json.cmd == "preview") {//跳转到预览页面
            window.open(printWorld.PrintURL() + '/' + json.val, '_blank'); //另启窗口预览（浏览器会出现阻止弹窗提示）。因此建议：预览使用Direct同步调用。
        } else if (json.cmd == "previewfile") {//跳转到预览页面
            window.open(printWorld.PrintURL() + '/' + json.val+"&file=1", '_blank'); //另启窗口预览（浏览器会出现阻止弹窗提示）。因此建议：预览使用Direct同步调用。
        } else if (json.cmd == "prnstatus") {//打印机状态
            //alert(json.printer.ready);
        } else if (json.cmd == "whoareyou") {
            //alert("Ready!");
        } else {
        }
    } else {
        if (this.statusText != null && this.statusText != undefined && this.statusText != "") {
            alert("Http error status:" + this.status.toString() + " : " + this.statusText);
        } else {
            alert("Http error status:" + this.status.toString());
        }
    }
}

classPrintWorld.prototype.DirectEx = function (json, callback,wait_in_ms) {
    if (wait_in_ms == undefined || wait_in_ms == null) {
        wait_in_ms = 1000;//毫秒
    }
    if (callback == undefined || callback == null) {
        callback = this.DirectExCallback;
    }
    var THIS = this;
    var result=THIS.Direct(json);
    if (result==null) {//first try,failed
        setTimeout(function () {
            result = THIS.Direct(json);
            if (result == null) {//second try,failed
                setTimeout(function () {
                    result = THIS.Direct(json);
                    if (result == null) {//third try,failed
                        callback(THIS, result);
                    } else {//third try,success
                        callback(THIS, result);
                    }
                }, wait_in_ms);
            } else {//second try,success
                callback(THIS, result);
            }
        }, wait_in_ms);
    } else {    //first try,success
        callback(THIS, result);
    }
}

classPrintWorld.prototype.DirectExCallback = function (printWorld, result) {
    if (result == null) {//数据发送失败
        alert(printWorld.GetLastError());
    } else if (result.error != undefined) {//打天下打印服务返回的错误信息
        alert(result.error);
    }
}

classPrintWorld.prototype.IsWindows = function () {
    var ua=navigator.userAgent.toLowerCase();
     return (/windows/.test(ua));
}

classPrintWorld.prototype.Browser = function () {
    var ua=navigator.userAgent.toLowerCase();
    if(/trident/.test(ua)) {
        return "msie"
    } else  if(/edge/.test(ua)) {
        return "edge"
    } else if(/chrome/.test(ua)) {
        return "chrome";
    } else if(/firefox/.test(ua)) {
        return "firefox";
    }
    return "unknown";
}
//////////////////////////////////////////////////////////
/**
* 打印机选择会话框
*/
classPrintWorld.prototype.PrintDialog = function (jsonData) {
    //this.jsonDataInDialog=jsonData;
    var THIS = this;
    var divDlg = document.getElementById("id_pw_divPrintDlg");
    if (null == divDlg) {
        divDlg = document.createElement('div');
        document.body.appendChild(divDlg);

        divDlg.setAttribute("id", "id_pw_divPrintDlg");
        divDlg.setAttribute("style", "box-shadow: 5px 5px 5px #888888;padding:0pt 0pt 0pt 0pt;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;color:Green");
        divDlg.style.backgroundColor = "LightGrey";
        divDlg.style.border = "solid 1px Gray";
       // divDlg.style.width = "-ms-fit-content";//"-webkit-fit-content";//"fit-content";//-moz-fit-content;fit-content";//
        //divDlg.style.width = "20em";
        //divDlg.style.display="table";
        //divDlg.style.float="none";
        //alert(THIS.IsWindows());
         var browser=THIS.Browser();
        if(browser!="chrome" && browser!="firefox") {
            divDlg.style.width = "280pt";
        }
        if(browser!="chrome") {
            divDlg.style.height = "100pt";
       }
       divDlg.style.zIndex = "9999";
        divDlg.style.position = "fixed";
        divDlg.style.top = "0";
        divDlg.style.left = "0";
        divDlg.style.right = "0";
        divDlg.style.bottom = "0";
        divDlg.style.textAlign = "center";
        divDlg.style.margin = "auto";
        divDlg.style.fontSize="10pt";//small";
        divDlg.style.fontFamily="微软雅黑";
        divDlg.style.color="Black";
        var html = "<table  border='0px'  cellspacing='5pt' cellpadding='0' style='font-size:10pt;color:Black;font-family:微软雅黑';><tr ><td style='width:45pt;height:20pt' valign='bottom'>打印机：</td><td valign='bottom'><select  id='id_pwPrinterSelInDlg' name='PrinterSelInDlg'  style='width:195pt'></select></td>";
        html += "<td  valign='bottom'><a  id='idRefreshInDlg' style='cursor:pointer;' >刷新</a></td>";
        html +="</tr></table>";
        html += "<table  border='0px'  cellspacing='5pt' cellpadding='0' style='height:20pt;font-size:10pt;color:Black;font-family:微软雅黑'><tr><td style='width:45pt'>状　态：</td><td id='idPrinterStatusInDlg' style=' text-align:left;font-size:small; font-family:微软雅黑; color:Black'></td></tr></table>";
        html += "<table  border='0px'  cellspacing='5pt' cellpadding='0' style='height:20pt;font-size:10pt;color:Black;font-family:微软雅黑'><tr><td style='width:45pt'>份　数：</td><td><input type='number' id='idCopiesInDlg' value='1'  min='1' max='100' style='width:40pt'/></td></tr></table>";
        html += "<table border='0px'  cellspacing='5pt' cellpadding='0' style='font-size:10pt;color:Black;font-family:微软雅黑'><tr><td style='width:160pt'></td><td style='width:60pt'><button type='button' id='idBtnOKPrint' style='width:60pt'>打印</button></td>";
        html += "<td style='width:60pt'><button type='button' id='idBtnCancelPrint'  style='width:60pt'>取消</button></td></tr></table>";
        divDlg.innerHTML = html;

        PrinterListInDlg(false);

        var selPrinters = document.getElementById("id_pwPrinterSelInDlg");
        selPrinters.onchange = function () {
            PrinterChangedInDlg(selPrinters.value);
        }

        var aRefresh = document.getElementById("idRefreshInDlg");
        aRefresh.onclick = function () {//Refresh printer list
            PrinterListInDlg(true);
        }

        //var btOK = document.getElementById("idBtnOKPrint");
        //btOK.onclick = function () {//Do print
         //   DoPrintInDlg();
        //}

        var btCancel = document.getElementById("idBtnCancelPrint");
        btCancel.onclick = function () {
            CancelPrintInDlg();
        }
    } else {
        document.getElementById('idCopiesInDlg').value='1';
    }
    divDlg.style.visibility = "visible"; //显示

    var btOK = document.getElementById("idBtnOKPrint");
    btOK.onclick = function () {//Do print
        DoPrintInDlg();
    }

    function PrinterListInDlg(refresh) {
        var json = {};
        json.action = "printers"; //获取打印机列表的JSON
        json.defaultprn = true;
        json.refresh=refresh;//true;
        json = THIS.Direct(json); //直接发送数据到打印服务器（同步调用方法）
        if (json == null) {//数据发送失败
        } else if (json.error != undefined) {//打天下打印服务返回的错误信息
        } else {
            var bLocalValid=false;
            if(localStorage.printerNameSelected!=null && localStorage.printerNameSelected!=undefined) {
                bLocalValid=true;
            }
            
            var sel = document.getElementById('id_pwPrinterSelInDlg'); 
            sel.options.length = 0; //清空列表
            sel.value="";
            //填充列表
            var prns = json.val;
            sel.options.add(new Option("", ""));
            for (var i = 0; i < prns.length; i++) {
                sel.options.add(new Option(prns[i].name, prns[i].name));
                if(bLocalValid) {
                    if(prns[i].name==localStorage.printerNameSelected) {
                        sel.value = prns[i].name;
                    }
                } else if (prns[i].default) {
                    sel.value = prns[i].name;
                }
            }
           
            if(sel.value=="" && prns.length>0) {
                sel.value = prns[0].name;
            }
            PrinterChangedInDlg(sel.value);
        }
    }

    function PrinterChangedInDlg(prnname) {
        localStorage.printerNameSelected = prnname;
        if (prnname == '') {
            document.getElementById("idPrinterStatusInDlg").innerHTML = "";
            return;
        }
        var json = {};
        json.action = "prnstatus";
        json.printer = prnname;
        json = THIS.Direct(json); //直接发送数据到打印服务器（同步调用方法)
        if (json == null) {//数据发送失败
        } else if (json.error != undefined) {//打天下打印服务返回的错误信息
        } else {
            document.getElementById("idPrinterStatusInDlg").innerHTML = json.printer.status;
        }
    }

    function CancelPrintInDlg() {
        if (divDlg != null) {
            divDlg.style.visibility = "hidden";
        }
    }

    function DoPrintInDlg() {
        if (divDlg == null) {
            return;
        }
        divDlg.style.visibility = "hidden";
       
        if (jsonData != null && jsonData != undefined) {
            var type = typeof (jsonData);
            if (type === 'object') {
            } else if (type === 'string') {
                try {
                    jsonData = JSON.parse(jsonData);
                } catch (err) {
                    gLastError = "Parse error in PrintDialog: " + err;
                    return;
                }
            } else {
                alert("PrintDialog: 不是JSON数据！");
                return;
            }
        }
        jsonData.printer = document.getElementById('id_pwPrinterSelInDlg').value; //打印机名称
        
        var copies=document.getElementById('idCopiesInDlg').value;
        if(copies=="") {
            jsonData.copies=1;
        } else {
            jsonData.copies=copies;
        }
       
        if (!THIS.Act(jsonData)) {
            alert(THIS.GetLastError()); //失败
        }
    }
}
